import * as React from 'react'
require('../base.module.scss')
import * as cn from 'classnames'
import * as st from './Grid.module.scss'

import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

export const Grid: React.ComponentType<BaseComponentProps> = (props: BaseComponentProps) => {
  const gridClassName = extractClassNamesFromProps(props, st.grid)
  return (
    <div className={gridClassName}>
      {React.Children.map(props.children, child => (
        (typeof child === 'number' || typeof child === 'string') ? null :
        React.cloneElement(child, {
          className: cn(
            st.gridItem,
            child.props.className
          )
        })
      ))}
    </div>
  )
}

// Add displayName to preserve the component name on snapshot testing
Grid.displayName = 'Grid'
